import keyMirror from 'keymirror-nested'

export default keyMirror({
  LOCATION_BUTTONS: {
    UPDATE: null,
    DELETE: null,
  },
})
